<template>
  <v-card flat>
    <FormField label="Nome da Forma de Entrega" v-model="form.nomeForma" />
    <FormField label="Token da api" v-model="form.intelipost.token" />
    <FormField
      label="Custo de separação"
      :money="form.intelipost.acrescimoTaxa === null ? null : moneyMask"
      v-model="form.intelipost.acrescimoTaxa"
    />
    <FormField
      label="Tempo de preparo e despacho em dias"
      v-model="form.intelipost.diasSeparacao"
      typeField="number"
      step="1"
      minField="0"
    />
    <FormField
      label="CEP de origem"
      v-model="form.intelipost.cepOrigem"
      typeField="number"
      mask="#####-###"
    />
    <h4>Método de cálculo</h4>
    <FormRadioGroup
      v-model="form.intelipost.metodoCalculo"
      inline
      :radios="metodosCalculo"
    />
  </v-card>
</template>

<script>
import FormField from "@/components/form/FormField";
import FormRadioGroup from "@/components/form/FormRadioGroup";

export default {
  name: "FormaEntregaFormInteliPost",
  components: {
    FormField,
    FormRadioGroup
  },
  props: {
    data: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
      moneyMask: {
        decimal: ",",
        thousands: " ",
        prefix: "",
        suffix: "",
        default: "",
        precision: 2,
        masked: false
      },
      form: {},
      metodosCalculo: [
        {
          label: "Embalagem única",
          help: "Todos os produtos são embalados em uma única caixa",
          value: "DYNAMIC_BOX_ALL_ITEMS"
        },
        {
          label: "Embalagem por item",
          help: "Cada produto é embalado individualmente",
          value: "DYNAMIC_BOX_SINGLE_ITEM"
        },
        {
          label: "Cálculo agrupado por sku",
          help: "Agrupa produtos pelo mesmo SKU em uma única embalagem",
          value: "DYNAMIC_BOX_BY_SKU"
        }
      ]
    };
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("update", this.form);
      }
    }
  },
  created() {
    this.form = this.data;
  }
};
</script>
